import { combineActions, handleActions } from 'redux-actions';
import { combineReducers } from 'redux';
import * as actionTypes from './constants';
import overviewReducer from './overview/search-results-overview-reducer';
import typeReducer from './type/search-results-type-reducer';
import relationsReducer from './relations/search-relations-reducer';

export const searchValue = handleActions({
  [actionTypes.SEARCH_REQUEST]: (state, action) => action.payload.searchValue,
  [actionTypes.SEARCH_BY_TYPE_REQUEST]: (state, action) => action.payload.searchValue,
  [actionTypes.CLEAR_SEARCH]: () => '',
}, '');

export const searchValuesByType = handleActions({
  [combineActions(
    actionTypes.SEARCH_VALUE_BY_TYPE_REQUEST,
    'LOCATION_CHANGE',
  )]: () => [],
  [actionTypes.SEARCH_VALUE_BY_TYPE_SUCCESS]: (state, action) => action.payload.items,
}, []);

export const isSearching = handleActions({
  [combineActions(
    actionTypes.SEARCH_VALUE_BY_TYPE_SUCCESS,
    actionTypes.SEARCH_VALUE_BY_TYPE_FAILURE,
  )]: () => false,
  [actionTypes.SEARCH_VALUE_BY_TYPE_REQUEST]: () => true,
}, false);

export const searchFilters = handleActions({
  [combineActions(
    actionTypes.SEARCH_FILTERS_REQUEST,
    actionTypes.SEARCH_FILTERS_REQUEST_FAILURE,
  )]: () => ({}),
  [actionTypes.SEARCH_FILTERS_REQUEST_SUCCESS]: (action, { payload }) => payload,
}, {});

export const isLoadingFilters = handleActions({
  [combineActions(
    actionTypes.SEARCH_FILTERS_REQUEST_FAILURE,
    actionTypes.SEARCH_FILTERS_REQUEST_SUCCESS,
  )]: () => false,
  [actionTypes.SEARCH_FILTERS_REQUEST]: () => true,
}, false);

export default combineReducers({
  searchValue,
  searchValuesByType,
  overview: overviewReducer,
  type: typeReducer,
  relations: relationsReducer,
  isSearching,
  searchFilters,
  isLoadingFilters,
});
